import { Vue, newVue } from '@/config/vue'

On.VueInit({
  controller: 'careers',
  init() {
    const Careers = Vue.component('careers', () =>
      import(/* webpackChunkName: "careers" */ './Careers.vue')
    )
    newVue({
      render: h => h(Careers),
      mount: '.careers',
    })
  },
})
